import React from "react";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

const EDITION_META = {
  express: { label: "Express+", subtitle: "Kleine Installationen" },
  professional: { label: "Professional+", subtitle: "Mittelgroß" },
  expert: { label: "Expert", subtitle: "Mittel bis groß" },
  corporate: { label: "Corporate", subtitle: "Kritisch / verteilt" },
};

const ORDER = ["express", "professional", "expert", "corporate"];

export default function LiveScorePanel({ recommendation, onEditionClick, compact = false }) {
  const scores = recommendation?.scores || { express: 0, professional: 0, expert: 0, corporate: 0 };
  const recommended = recommendation?.recommendedEdition;

  return (
    <Card data-testid="live-score-panel" className="p-4 md:p-5 border-border bg-card/80 card-elev sticky top-24">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">Live-Eignung</h3>
        {recommendation && (
          <span className="text-[10px] text-muted-foreground">aktualisiert live</span>
        )}
      </div>
      <div className={cn("grid gap-3", compact ? "grid-cols-2" : "grid-cols-1")}>
        {ORDER.map((ed) => {
          const isRec = recommended === ed;
          const pct = scores[ed] || 0;
          return (
            <button
              key={ed}
              type="button"
              data-testid={`live-score-${ed}`}
              onClick={() => onEditionClick && onEditionClick(ed)}
              className={cn(
                "text-left rounded-lg border p-3 tile-hover transition-all",
                isRec
                  ? "border-primary bg-primary/10 ring-1 ring-primary/40"
                  : "border-border bg-secondary/40 hover:bg-secondary/60"
              )}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  {isRec && <Star className="w-4 h-4 text-primary fill-primary" />}
                  <span className={cn("font-semibold text-sm", isRec ? "text-primary" : "text-foreground")}>
                    {EDITION_META[ed].label}
                  </span>
                </div>
                <span className="text-lg font-bold tabular-nums">{pct}%</span>
              </div>
              <div className="text-xs text-muted-foreground mb-2">{EDITION_META[ed].subtitle}</div>
              <Progress value={pct} className="h-1.5" />
            </button>
          );
        })}
      </div>
      {!recommendation && (
        <p className="text-xs text-muted-foreground mt-4">
          Beginnen Sie mit der Beantwortung — die Eignung wird live berechnet.
        </p>
      )}
    </Card>
  );
}
